import { axios, APIBASE_REVIVERCLAIMS } from "./ApiConfig";
import { QueryClient, useQuery } from "@tanstack/react-query";
import { Claim, ClaimAdminReviewRequest, RegisterClaim } from "@/types";

export const postRegisterClaim = async (claim: RegisterClaim) =>
  axios.post(`${APIBASE_REVIVERCLAIMS}api/claims/register`, claim);

const getClaimsByOrderId = async (orderId: number) => axios.get(`${APIBASE_REVIVERCLAIMS}api/claims/order/${orderId}`);

export const useGetClaimsByOrderId = (orderId: number, options?: any) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<Claim[] | undefined>({
    queryKey: ["getClaimsByOrderId", orderId],
    queryFn: async () => {
      const result = await getClaimsByOrderId(orderId);
      return result.data;
    },
    ...queryOptions,
  });
};

export const prefetchClaimsByOrderId = (queryClient: QueryClient, orderId: number) =>
  queryClient.prefetchQuery({
    queryKey: ["getClaimsByOrderId", orderId],
    queryFn: async () => (await getClaimsByOrderId(orderId)).data as Claim[],
    staleTime: 30_000,
  });

const getClaimsAll = async () => axios.get(`${APIBASE_REVIVERCLAIMS}api/claims/all`);

export const useGetClaimsAll = (options?: any) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<Claim[] | undefined>({
    queryKey: ["getClaimsAll"],
    queryFn: async () => {
      const result = await getClaimsAll();
      return result.data;
    },
    ...queryOptions,
  });
};

export const putUpdateClaim = async (claim: any) => {
  return axios.put(`${APIBASE_REVIVERCLAIMS}api/claims/update`, claim);
};

export const putReviewClaim = async (claim: ClaimAdminReviewRequest) => {
  return axios.put(`${APIBASE_REVIVERCLAIMS}api/claims/review`, claim);
};
